import mixins from 'vue-typed-mixins';

import C計画書データ表示設定CheckBox from '@/components/計画書データ表示設定CheckBox/計画書データ表示設定CheckBox.vue';

import 計画損益計算表Mixin from '@/entries/user/mixins/計画損益計算表Mixin';
import 計画PlbscfMonitoringMixin from '@/entries/user/mixins/計画PlbscfMonitoringMixin';

import Abstract計画PlbscfService, { 計画Plbscf } from '@/classes/service/Abstract計画PlbscfService';

export default mixins(計画損益計算表Mixin, 計画PlbscfMonitoringMixin).extend({
  name: 'M計画Plbscf業績予測Mixin',

  components: {
    C計画書データ表示設定CheckBox,
  },

  data(): {
    計画Plbscf: 計画Plbscf;
  } {
    return {
      計画Plbscf: {
        bs: {
          header: [],
          list: [],
        },
        pls: [],
        types: [],
        補助科目別貸借対照表: {
          header: [],
          list: [],
        },
        科目別損益計算書: {
          header: [],
          科目別計画s: [],
        },
      },
    };
  },

  watch: {
    計画Plbscf: {
      handler(newVal: 計画Plbscf, oldVal: 計画Plbscf): void {
        // load時は再計算せず終了
        if (this.isLoading) {
          this.isLoading = false;
          return;
        }
        if (oldVal.types.length === 0) return;
        // 値変更時、編集中フラグを立てる
        this.isEditing = true;
      },
      deep: true,
    },
  },

  methods: {
    async loadByService(service: Abstract計画PlbscfService<計画Plbscf>): Promise<void> {
      this.計画Plbscf = await this.loadAndParse(service);
    },
  },
});
